<template lang="pug">
a(v-if="imgurl" :href="imgurl" target="_blank")
    slot Download
span(v-else-if="error") Not Found
span(v-else) Loading...
</template>
<script setup lang="ts">
import { useDocuments } from '@/store/useDocuments';
import { ref, watch } from 'vue';

const documents = useDocuments();

type Props = {
    docRef: string
}
const props = defineProps<Props>();

const imgurl = ref<string | null>(null);
const error = ref<string | null>(null);

watch(() => props.docRef, async r => {
    try {
        const url = await documents.getUrl(r);
        if (!url) throw new Error("Can't find doc");
        imgurl.value = url;
    } catch (e) {
        console.error(e);
        error.value = (e as Error).message;
    }
}, { immediate: true });
</script>